<template>
  <span class="badge-container">
    <v-badge overlap :color="badgeColor" v-if="badgeIcon || secondaryBadgeIcon">
      <template v-slot:badge>
        <v-icon
          dark
          @click="$emit('badge:action:click', item)"
          v-if="secondaryBadgeIcon"
        >
          {{ secondaryBadgeIcon }}
        </v-icon>
        <v-icon
          dark
          @click="$emit('badge:action:click', item)"
          v-if="badgeIcon && badgeIcon.includes('mdi-')"
        >
          {{ badgeIcon }}
        </v-icon>
        <span v-else>{{ badgeIcon }}</span>
      </template>
      <div :class="[selected ? 'badge-selected' : 'badge-wrapper']">
        <div class="badge" @click="$emit('badge:click', item)">
          <img
            class="badge-image"
            :src="`${imageUrl ? imageUrl : '/default_badge.svg'}`"
          />
        </div>
        <span :class="[completed ? 'completed-item' : '']">{{ title }}</span>
      </div>
    </v-badge>
    <div :class="[selected ? 'badge-selected' : 'badge-wrapper']" v-else>
      <div class="badge" @click="$emit('badge:click', item)">
        <img
          class="badge-image"
          :src="`${imageUrl ? imageUrl : '/default_badge.svg'}`"
        />
      </div>
      <span :class="[completed ? 'completed-item' : '']">{{ title }}</span>
    </div>
  </span>
</template>

<script>
import eventMixin from "@/mixins/eventMixin"
export default {
  mixins: [eventMixin],
  props: {
    badgeIcon: { type: String },
    badgeColor: { type: String },
    secondaryBadgeIcon: { type: String },
    completed: { type: Boolean, default: false },
    imageUrl: { type: String },
    item: { type: Object, default: () => {} },
    title: { type: String },
    selected: { type: Boolean, default: false }
  },
  methods: {
    deleteItem(gridItemId) {
      if (confirm("Are you sure you want to delete this? OK to delete.")) {
        this.fireEvent("grid:removeItem", gridItemId)
      }
    },
    event(item) {
      this.$emit(
        "badge-click",
        new CustomEvent({
          bubbles: true,
          cancelable: true,
          currentTarget: item
        })
      )
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../scss/variables";

img.badge-image {
  height: 96px;
  width: 96px;
  border-radius: 23px;
  padding: 10px;
}
div.badge {
  background-color: $dark-blue;
  border-style: solid;
  border-width: 1px;
  border-radius: 25px;
  width: 100px;
  height: 100px;
  cursor: pointer;
  border-color: $light-grey;
}

div.badge-wrapper {
  width: 100px;
  text-align: center;
  color: $dark-grey;
  font-style: italic;
}
div.badge-selected {
  width: 100px;
  border-color: red;
  color: red;
  text-align: center;
}
.completed-item {
  text-decoration: line-through;
}
span.badge-container {
  padding: 12px;
}
</style>
